import './Season.css';
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import ProgressCell from "./ProgressCell";
import {Navigation, Scrollbar} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import React, {useEffect, useRef} from "react";
import {useActions} from "../../../../hooks/useActions";
import {config} from "../../../../config";

function SeasonProgress() {

    const {user} = useTypedSelector(state => state.auth);
    const {setRoute} = useActions();

    const paid = user.season_progress.progress.paid;
    const free = user.season_progress.progress.free;

    let progressClassAdsActive = 'progressContainerAdsActive';

    if (user.premium) {
        progressClassAdsActive = '';
    }

    const swiperRef: any = useRef();

    useEffect(() => {
        swiperRef.current.slideTo(user.season_progress.currentLevel - 1, 1500);
    }, [swiperRef]);

    return <div className={'seasonContainer'}>
        {(user.premium) ?
            <div></div>
            :
            <div className={'seasonAds'}>
                <div className={'seasonAdsButton defaultButtonAnimation_5'} onClick={() => {
                    if(config.isNutaku) {
                        setRoute('gem_shop');
                    }else {
                        window.open("https://www.patreon.com/c/depravedworld", "_blank");
                    }
                }}></div>
            </div>
        }

        <div className={'progressContainer ' + progressClassAdsActive}>

            <Swiper
                modules={[Navigation, Scrollbar]}
                spaceBetween={0}

                scrollbar={{draggable: true}}
                loop={false}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 9, // phones, tablets, small laptops
                    },
                    1600: {
                        slidesPerView: 12, // full HD+ desktops
                    },
                    2000: {
                        slidesPerView: 15, // full HD+ desktops
                    },
                }}
            >
                {Object.keys(paid).map((item, index) => {

                    let currentClass = '';
                    if (user.season_progress.currentLevel === (parseInt(item) + 1)) {
                        currentClass = 'progressCurrent';
                    }

                    return <SwiperSlide key={'progress_slide_' + item}>

                        {((parseInt(item) + 1) === config.MAX_SEASON_LEVEL) ?
                            <div className={'progressLastItem'}>
                                <div className={'progressLastItemHack'}></div>
                            </div>
                            :
                            <ProgressCell key={'ProgressCell_' + item} item={item} currentClass={currentClass}
                                          paid={paid}
                                          free={free}
                                          user={user}/>

                        }
                    </SwiperSlide>

                })}
            </Swiper>
        </div>

    </div>
}

export default SeasonProgress;
